import React, { useState, useRef, useEffect, useCallback } from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import LightGestion from 'components/headers/lightGestion';
import { Button, Form, Row, Col, Card } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from 'axios';

// IMPORT DE VOTRE LOGO LOCAL
import logo from "../../images/logo.png";

const RapportPerformance = () => {
  const [formData, setFormData] = useState({
    nomClient: '',
    nomCampagne: '',
    budgetCampagne: '',
    budgetJour: '',
    objectif: '',
    sexe: 'Tous',
    age: '',
    impression: '',
    vues: '',
    conversations: '', 
    budgetConv: '',    
    dateDebut: '16/02/2026',
    dateFin: '16/02/2026'
  });

  const [company, setCompany] = useState({ 
    name: 'AgencyWmg', 
    address: 'Siège social : AGENCY WMG - miftah el kheyer rue palestine bureau 1 étages - Setat - MAROC', 
    phone: '0661735472',
    email: 'agencywmg@gmail.com',
    ice: '003791501000072',
    rc: '169291',
    if: '68375561'
  });

  const reportRef = useRef(null);
  const dateToday = "16/02/2026"; 
  const reportRefNumber = `RAP-2026-${Math.floor(1000 + Math.random() * 9000)}`;

  // Fonction d'attente pour s'assurer que le logo est rendu
  const waitForImages = useCallback(async (rootEl) => {
    if (!rootEl) return;
    const imgs = Array.from(rootEl.querySelectorAll('img'));
    await Promise.all(imgs.map(img => new Promise(resolve => {
      if (img.complete && img.naturalWidth > 0) return resolve();
      img.onload = img.onerror = resolve;
    })));
  }, []);

  useEffect(() => {
    const fetchSociete = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await axios.get('https://plateformewmg.cloud/api/Gestion/societe', {
          headers: { Authorization: token ? `Bearer ${token}` : '' }
        });
        const payload = res.data?.data?.societe?.[0] || res.data?.[0];
        if (payload) {
          setCompany(prev => ({ 
            ...prev,
            name: payload.Nom, 
            address: payload.Address, 
            phone: payload.Telephone,
            email: payload.Email,
            ice: payload.ICE,
            rc: payload.RC,
            if: payload.IF
          }));
        }
      } catch (err) { console.error("Erreur API", err); }
    };
    fetchSociete();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDownload = async () => {
    const node = reportRef.current;
    if (!node) return;

    await waitForImages(node);

    const canvas = await html2canvas(node, { 
      scale: 3, 
      useCORS: true, 
      backgroundColor: '#ffffff' 
    });
    
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, (canvas.height * pageWidth) / canvas.width);
    pdf.save(`Rapport_${formData.nomClient || 'Performance'}.pdf`);
  };

  const darkInputStyle = { 
    background: '#2d3238', 
    border: '1px solid #444', 
    color: '#fff',
    borderRadius: '8px',
    marginBottom: '15px'
  };

  return (
    <AnimationRevealPage>
      <LightGestion />
      <div className="container mt-4" style={{ maxWidth: "1000px" }}>
        
        <Card className="p-4 shadow-lg border-0" style={{ background: '#1a1d21', color: '#fff' }}>
          <h3 className="fw-bold mb-4">Configuration du Rapport</h3>
          <Form>
            <Row>
              <Col md={12}>
                <Form.Label className="small fw-bold text-light">Adressé à (Nom du Client)</Form.Label>
                <Form.Control name="nomClient" style={darkInputStyle} onChange={handleChange} placeholder="Ex: Myaorganic" />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Du</Form.Label>
                <Form.Control name="dateDebut" style={darkInputStyle} onChange={handleChange} defaultValue="16/02/2026" />
              </Col>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Au</Form.Label>
                <Form.Control name="dateFin" style={darkInputStyle} onChange={handleChange} defaultValue="16/02/2026" />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Nom de Campagne</Form.Label>
                <Form.Control name="nomCampagne" style={darkInputStyle} onChange={handleChange} />
              </Col>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Budget Total</Form.Label>
                <Form.Control name="budgetCampagne" style={darkInputStyle} onChange={handleChange} />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Budget Jour</Form.Label>
                <Form.Control name="budgetJour" style={darkInputStyle} onChange={handleChange} />
              </Col>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Objectif</Form.Label>
                <Form.Control name="objectif" style={darkInputStyle} onChange={handleChange} />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Sexe</Form.Label>
                <Form.Select name="sexe" style={darkInputStyle} onChange={handleChange}>
                  <option value="Tous">Tous</option>
                  <option value="Hommes">Hommes</option>
                  <option value="Femmes">Femmes</option>
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Âge</Form.Label>
                <Form.Control name="age" style={darkInputStyle} onChange={handleChange} />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Impression</Form.Label>
                <Form.Control name="impression" style={darkInputStyle} onChange={handleChange} />
              </Col>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Vues</Form.Label>
                <Form.Control name="vues" style={darkInputStyle} onChange={handleChange} />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Conversations</Form.Label>
                <Form.Control name="conversations" style={darkInputStyle} onChange={handleChange} />
              </Col>
              <Col md={6}>
                <Form.Label className="small fw-bold text-light">Budget/Conv</Form.Label>
                <Form.Control name="budgetConv" style={darkInputStyle} onChange={handleChange} />
              </Col>
            </Row>

            <div className="d-grid mt-4">
              <Button onClick={handleDownload} style={{ background: '#3b82f6', border: 'none', fontWeight: 'bold', padding: '12px' }}>
                Générer Rapport PDF
              </Button>
            </div>
          </Form>
        </Card>

        {/* --- TEMPLATE PDF --- */}
        <div style={{ position: 'absolute', left: '-9999px' }}>
          <div ref={reportRef} style={{ width: '210mm', minHeight: '297mm', padding: '20mm', background: '#fff', color: '#000', fontFamily: 'Arial', position: 'relative', display: 'flex', flexDirection: 'column' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
              <div>
                {/* UTILISATION DU LOGO IMPORTÉ */}
                <img 
                  src={logo} 
                  alt="logo" 
                  style={{ maxHeight: '80px', width: 'auto', display: 'block' }} 
                />
              </div>
              <div style={{ textAlign: 'right' }}>
                <h3 style={{ color: '#3b82f6', fontWeight: 'bold', margin: 0, fontSize: '18px' }}>Rapport de Performance</h3>
                <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>Réf. : {reportRefNumber}</p>
                <p style={{ margin: 0, fontSize: '12px' }}>Date : {dateToday}</p>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '30px', marginBottom: '35px', marginTop: '20px' }}>
              <div style={{ flex: 1.2, borderLeft: '3px solid #3b82f6', paddingLeft: '15px' }}>
                <p style={{ margin: 0, fontSize: '10px', color: '#888', fontWeight: 'bold', textTransform: 'uppercase' }}>ÉMETTEUR :</p>
                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontSize: '15px' }}>{company.name}</p>
                <p style={{ margin: 0, fontSize: '11px', color: '#333', lineHeight: '1.5' }}>
                  {company.email}<br/>{company.phone}<br/>{company.address}
                </p>
              </div>
              <div style={{ flex: 1, textAlign: 'right', borderRight: '3px solid #ddd', paddingRight: '15px' }}>
                <p style={{ margin: 0, fontSize: '10px', color: '#888', fontWeight: 'bold', textTransform: 'uppercase' }}>ADRESSÉ À :</p>
                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', fontSize: '18px' }}>{formData.nomClient || "Client"}</p>
              </div>
            </div>

            <h4 style={{ textAlign: 'center', fontWeight: 'bold', textDecoration: 'underline', marginBottom: '15px', fontSize: '16px' }}>
               RAPPORT DE PERFORMANCE PUBLICITAIRE
            </h4>
            
            <p style={{ fontSize: '13px', marginBottom: '15px' }}>
              <strong>Période :</strong> Du {formData.dateDebut} Au {formData.dateFin}
            </p>

            <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000' }}>
              <thead>
                <tr style={{ height: '45px', backgroundColor: '#f2f2f2' }}>
                  <th style={{ border: '2px solid #000', color: 'black', fontStyle: 'italic', textAlign: 'center', fontSize: '13px' }}>INDICATEURS</th>
                  <th style={{ border: '2px solid #000', color: 'black', fontStyle: 'italic', textAlign: 'center', fontSize: '13px' }}>LE NOM</th>
                  <th style={{ border: '2px solid #000', color: 'black', fontStyle: 'italic', textAlign: 'center', fontSize: '13px' }}>LE NOMBRE</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { label: "Nom de Campagne", val: formData.nomCampagne, num: "" },
                  { label: "Budget du Jour", val: "", num: formData.budgetJour },
                  { label: "Objectif de la campagne", val:formData.objectif, num:"" },
                  { label: "Sexe", val: formData.sexe, num: "" },
                  { label: "Âge de ciblage", val: "", num: formData.age },
                  { label: "Impression", val: "", num: formData.impression },
                  { label: "Vues de publicité", val: "", num: formData.vues },
                  { label: "Nombre de conversations / visiteur", val: "", num: formData.conversations },
                  { label: "Budget par conversation / site", val: "", num: formData.budgetConv },
                  { label: "Totale de publicité", val: "", num: formData.budgetCampagne }
                ].map((row, i) => (
                  <tr key={i} style={{ height: '38px' }}>
                    <td style={{ border: '2px solid #000', paddingLeft: '12px', fontWeight: 'bold', fontSize: '12px' }}>{row.label}</td>
                    <td style={{ border: '2px solid #000', textAlign: 'center', fontSize: '12px' }}>{row.val}</td>
                    <td style={{ border: '2px solid #000', textAlign: 'center', fontSize: '12px' }}>{row.num}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={{ marginTop: 'auto', borderTop: '2px solid #000', paddingTop: '10px', textAlign: 'center', fontSize: '10px' }}>
              <p style={{ fontWeight: 'bold', margin: '0 0 2px 0', fontSize: '12px' }}>{company.name}</p>
              <p style={{ margin: 0, color: '#333' }}>{company.address}</p>
              <p style={{ margin: 0, color: '#666' }}>
                {company.rc && `RC: ${company.rc} | `} {company.if && `IF: ${company.if} | `} {company.ice && `ICE: ${company.ice}`}
              </p>
            </div>

          </div>
        </div>
      </div>
    </AnimationRevealPage>
  );
};

export default RapportPerformance;